(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moonstar-product-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moonstar-product-rating')) {
  customElements.define('moonstar-product-rating', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const target = document.getElementById(`moonstar-product-reviews-${this.dataset.productId}`);
        if (!target) return;
        event.preventDefault(); event.stopPropagation();
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        target.querySelector('h2')?.focus({ preventScroll: true });
      }, { capture: true, signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moonstar-reward-bar"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__moonstarRewardBarInstalled) return;
  window.__moonstarRewardBarInstalled = true;

  const unlockDuration = 1800;
  const refreshDelay = 350;
  const settleDelay = 120;
  const missingGrace = 1200;
  const unlockMessages = [
    "YOU'VE UNLOCKED FREE SHIPPING!",
    "YOU'VE UNLOCKED YOUR FIRST FREE GIFT!",
    "YOU'VE UNLOCKED YOUR SECOND FREE GIFT!",
    "YOU'VE UNLOCKED YOUR THIRD FREE GIFT!"
  ];
  const starShape = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 375 375\"><path fill=\"#ffbcca\" d=\"M 205.324219 268.34375 L 319.449219 318.234375 L 256.324219 210.957031 L 339.242188 119.292969 L 218.628906 145.886719 L 153.890625 35.074219 L 141.757812 162.835938 L 21.144531 189.429688 L 134.917969 237.726562 L 122.894531 361.570312 Z M 205.324219 268.34375 \"/><path fill=\"COLOR\" d=\"M 202.222656 254.507812 L 296.558594 295.742188 L 244.378906 207.070312 L 312.917969 131.300781 L 213.21875 153.28125 L 159.707031 61.683594 L 149.675781 167.292969 L 49.976562 189.277344 L 144.023438 229.199219 L 134.085938 331.566406 Z M 202.222656 254.507812 \"/><path fill=\"#ffffff\" d=\"M 198.019531 242.941406 L 265.363281 272.378906 L 228.113281 209.074219 L 277.042969 154.984375 L 205.871094 170.675781 L 167.667969 105.289062 L 160.507812 180.679688 L 89.335938 196.371094 L 156.472656 224.871094 L 149.375 297.953125 Z M 198.019531 242.941406 \"/></svg>";
  const starMarkup = { red: starShape.replace("COLOR", "#d2100c"), blue: starShape.replace("COLOR", "#65dfe7") };
  const starSources = Object.fromEntries(Object.entries(starMarkup).map(([color, svg]) => [color, `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`]));
  const states = new Map();
  let observer;
  let drawerObserver;
  let watchedDrawer;
  let scheduled = false;
  let refreshTimer;
  let settleTimer;
  let guestView;
  let lastDrawerRefresh = 0;

  const bounded = value => Math.max(0, Math.min(100, value));
  const textOf = node => node?.textContent?.trim() || '';

  function readBar(native) {
    const title = textOf(native.querySelector('.ego-milestones-title'));
    const layout2 = [...native.querySelectorAll('.ego-layout2-milestone')];
    const layout1 = [...native.querySelectorAll('.ego-layout1-milestone')];
    const items = layout2.length ? layout2 : layout1;
    if (!title || !items.length) return null;

    const complete = item => layout2.length
      ? item.classList.contains('ego-completed')
      : !!item.querySelector('.ego-completed');
    const next = items.findIndex(item => !complete(item));
    const completed = next === -1 ? items.length : next;
    let percent = 100;

    if (next !== -1 && layout2.length) {
      const fill = items[next].querySelector('.ego-layout2-milestone-bar-fill');
      if (!fill || !fill.style.width) return null;
      percent = Number.parseFloat(fill.style.width);
    } else if (next !== -1) {
      const fill = native.querySelector('.ego-layout1-fill');
      if (!fill || !fill.style.width) return null;
      percent = Number.parseFloat(fill.style.width) * items.length - completed * 100;
    }

    if (!Number.isFinite(percent)) return null;
    const labels = items.map(item => textOf(item.querySelector('.ego-milestone-primary-text')));
    return { title, completed, count: items.length, percent: bounded(percent), labels };
  }

  function matchingCampaign(data) {
    const settings = window.EgoFreeGiftSettings?.settings;
    const api = window.EgoCore?.widget;
    if (!api?.isDateCampaignActive || !api?.checkPageLevelSubConditions) return null;
    return (settings?.active_campaigns || []).find(campaign => {
      if (campaign.type !== 'milestone' || !api.isDateCampaignActive(campaign)) return false;
      if (!api.checkPageLevelSubConditions(campaign.customerBuyCartSetting?.subConditions)) return false;
      if (!campaign.milestoneShowRewardSetting?.isShowTheBundleWidgetOnCartPage) return false;
      const tiers = [...(campaign.giftMilestoneSetting?.milestones || [])]
        .sort((a, b) => a.buyAtLeast - b.buyAtLeast);
      return tiers.length === data.count && tiers.every((tier, i) => tier.name === data.labels[i]);
    }) || null;
  }

  function campaignFor(data) {
    try { return matchingCampaign(data); } catch { return null; }
  }

  function unlockMessage(campaign, completed) {
    if (!campaign || !completed) return '';
    const tiers = campaign.giftMilestoneSetting?.milestones || [];
    const sorted = [...tiers].sort((a, b) => a.buyAtLeast - b.buyAtLeast);
    const index = tiers.findIndex(tier => tier.id === sorted[completed - 1]?.id);
    const message = campaign.giftDisplaySetting?.mileStoneNotification?.[index];
    return typeof message === 'string' ? message.trim() : '';
  }

  function makeStar(kind) {
    const star = document.createElement('img');
    star.className = `ms-reward-star ms-reward-star--${kind}`;
    star.alt = '';
    star.setAttribute('aria-hidden', 'true');
    star.width = 500;
    star.height = 500;
    star.src = starSources[kind === 'moving' ? 'red' : 'blue'];
    star.draggable = false;
    return star;
  }

  function makeView() {
    const view = document.createElement('div');
    view.className = 'ms-reward-view';
    view.dir = 'ltr';
    const message = document.createElement('p');
    message.className = 'ms-reward-message';
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.setAttribute('aria-atomic', 'true');
    const rail = document.createElement('div');
    rail.className = 'ms-reward-rail';
    rail.setAttribute('role', 'progressbar');
    rail.setAttribute('aria-valuemin', '0');
    rail.setAttribute('aria-valuemax', '100');
    const track = document.createElement('div');
    track.className = 'ms-reward-track';
    const fill = document.createElement('div');
    fill.className = 'ms-reward-fill';
    rail.append(track, fill, makeStar('goal'), makeStar('moving'));
    view.append(message, rail);
    return view;
  }

  function paint(state) {
    if (!state.view || !state.data) return;
    const flashing = state.flash && Date.now() < state.flashUntil;
    const rawTitle = flashing ? state.flash : state.data.title;
    const milestoneMatch = rawTitle.match(/^you['’]ve unlocked milestone\s*#?\s*(\d+)\s*!?$/i);
    const title = (milestoneMatch
      ? unlockMessages[Number(milestoneMatch[1]) - 1] || rawTitle
      : rawTitle).toUpperCase();
    const percent = flashing ? 100 : state.data.percent;
    const stage = flashing ? `unlocked-${state.data.completed}` : `next-${state.data.completed}`;
    const reset = state.view.dataset.stage !== stage;
    const colorStage = flashing ? Math.max(0, state.data.completed - 1) : Math.min(state.data.completed, state.data.count - 1);
    const blueFill = colorStage % 2 === 1;
    state.view.dataset.fillColor = blueFill ? 'blue' : 'red';
    const moving = state.view.querySelector('.ms-reward-star--moving');
    const goal = state.view.querySelector('.ms-reward-star--goal');
    const movingSource = starSources[blueFill ? 'blue' : 'red'];
    const goalSource = starSources[blueFill ? 'red' : 'blue'];
    if (moving.getAttribute('src') !== movingSource) moving.src = movingSource;
    if (goal.getAttribute('src') !== goalSource) goal.src = goalSource;
    const message = state.view.querySelector('.ms-reward-message');
    const rail = state.view.querySelector('.ms-reward-rail');
    if (textOf(message) !== title) message.textContent = title;
    const view = state.view;
    if (reset) {
      cancelAnimationFrame(state.resetFrame);
      view.dataset.reset = 'true';
    }
    state.view.dataset.stage = stage;
    state.view.dataset.complete = String(!!flashing || state.data.completed === state.data.count);
    const width = `${Math.round(percent * 1000) / 1000}%`;
    if (state.view.style.getPropertyValue('--ms-reward-progress') !== width) {
      state.view.style.setProperty('--ms-reward-progress', width);
    }
    const value = String(Math.round(percent));
    if (rail.getAttribute('aria-valuenow') !== value) rail.setAttribute('aria-valuenow', value);
    if (rail.getAttribute('aria-valuetext') !== title) rail.setAttribute('aria-valuetext', title);
    if (rail.getAttribute('aria-label') !== title) rail.setAttribute('aria-label', title);
    if (reset) state.resetFrame = requestAnimationFrame(() => {
      state.resetFrame = requestAnimationFrame(() => { delete view.dataset.reset; });
    });
  }

  function mount(drawer, view) {
    const host = drawer.querySelector('.cart-drawer__inner') || drawer;
    if (view.parentElement !== host || host.firstElementChild !== view) host.prepend(view);
  }

  function accept(state, data, campaign) {
    const signature = JSON.stringify(data.labels);
    const changedCampaign = state.signature !== signature || (state.campaignId && campaign?.id && state.campaignId !== campaign.id);
    if (changedCampaign || state.completed === undefined) {
      clearTimeout(state.timer);
      state.flash = '';
      state.flashUntil = 0;
      state.announced = new Set(Array.from({ length: data.completed }, (_, i) => i + 1));
    } else if (data.completed > state.completed && !state.announced.has(data.completed)) {
      for (let i = 1; i <= data.completed; i++) state.announced.add(i);
      const message = data.completed < data.count ? unlockMessage(campaign, data.completed) : '';
      if (message) {
        clearTimeout(state.timer);
        state.flash = message;
        state.flashUntil = Date.now() + unlockDuration;
        state.timer = setTimeout(() => { state.flash = ''; paint(state); }, unlockDuration);
      }
    }
    if (data.completed < (state.completed ?? 0) || data.completed === data.count) {
      clearTimeout(state.timer);
      state.flash = '';
      state.flashUntil = 0;
    }
    state.signature = signature;
    state.campaignId = campaign?.id || (changedCampaign ? null : state.campaignId);
    state.completed = data.completed;
    state.data = data;
    state.view ||= makeView();
    paint(state);
  }

  function refresh() {
    scheduled = false;
    clearTimeout(settleTimer);
    const drawer = document.getElementById('cart-drawer');
    if (watchedDrawer !== drawer) {
      drawerObserver?.disconnect();
      watchedDrawer = drawer;
      if (drawer) {
        drawerObserver = new MutationObserver(records => {
          if (records.some(relevantMutation)) schedule();
        });
        drawerObserver.observe(drawer, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['class', 'style']
        });
      }
    }
    if (!drawer) return;
    const accountTemplate = document.getElementById('moonstar-reward-bar-enabled');
    if (accountTemplate?.dataset.customerLoggedIn === 'false') {
      for (const state of states.values()) {
        clearTimeout(state.timer);
        state.view?.remove();
      }
      states.clear();
      guestView ||= document.createElement('div');
      if (!guestView.firstElementChild) {
        guestView.className = 'ms-reward-view ms-reward-view--signin';
        guestView.append(accountTemplate.content.cloneNode(true));
      }
      drawer.querySelectorAll('.ms-reward-view').forEach(view => {
        if (view !== guestView) view.remove();
      });
      mount(drawer, guestView);
      return;
    }
    guestView?.remove();
    const now = Date.now();
    const liveSlots = new Set();
    let nextRefresh = Infinity;
    const bars = [...drawer.querySelectorAll('.ego-milestone-bar')];
    bars.forEach((native, index) => {
      const barAnchor = native.closest('.ego-milestone-bar-anchor');
      const slot = `${barAnchor?.dataset.location || 'cart'}:${index}`;
      let state = states.get(slot);
      let data;
      try { data = readBar(native); } catch { data = null; }
      if (!data) return;
      liveSlots.add(slot);
      if (!state) {
        state = { flashUntil: 0, flash: '', timer: null, resetFrame: 0 };
        states.set(slot, state);
      }
      state.missingSince = null;
      const fingerprint = JSON.stringify(data);
      if (!state.data || fingerprint === state.fingerprint) {
        state.pending = null;
        if (!state.data) {
          accept(state, data, campaignFor(data));
          state.fingerprint = fingerprint;
        }
      } else {
        if (state.pending?.fingerprint !== fingerprint) state.pending = { fingerprint, since: now };
        const remaining = settleDelay - (now - state.pending.since);
        if (remaining <= 0) {
          accept(state, data, campaignFor(data));
          state.fingerprint = fingerprint;
          state.pending = null;
        } else nextRefresh = Math.min(nextRefresh, remaining);
      }
      mount(drawer, state.view);
    });
    for (const [slot, state] of states) {
      if (liveSlots.has(slot)) continue;
      state.pending = null;
      state.missingSince ??= now;
      const remaining = missingGrace - (now - state.missingSince);
      if (remaining > 0) {
        if (state.view) mount(drawer, state.view);
        nextRefresh = Math.min(nextRefresh, remaining);
      } else {
        clearTimeout(state.timer);
        state.flash = '';
        state.view?.remove();
      }
    }
    if (Number.isFinite(nextRefresh)) settleTimer = setTimeout(schedule, Math.max(16, nextRefresh));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  function relevantMutation(record) {
    const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    if (target?.closest('.ms-reward-view')) return false;
    if (record.type === 'childList') {
      const nodes = [...record.addedNodes, ...record.removedNodes];
      if (nodes.length && nodes.every(node => node.nodeType === 1 && node.matches('.ms-reward-view'))) return false;
    }
    return true;
  }

  function start() {
    if (observer || !document.body || !document.getElementById('moonstar-reward-bar-enabled')) return;
    observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.id === 'cart-drawer' || !!node.querySelector('#cart-drawer'))
      ))) schedule();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('cart-drawer:refreshed', () => {
      lastDrawerRefresh = Date.now();
      schedule();
    });
    document.addEventListener('cart:change', schedule);
    document.addEventListener('ego:core-ready', schedule);
    window.addEventListener('ego:api:ready', schedule);
    window.addEventListener('pageshow', schedule);
    installCartSync();
    schedule();
  }

  function installCartSync() {
    if (window.__moonstarEgoCartSync) return;
    window.__moonstarEgoCartSync = true;
    const refreshDrawer = () => {
      schedule();
      const requestedAt = Date.now();
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        if (lastDrawerRefresh < requestedAt && document.getElementById('cart-drawer')) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      }, refreshDelay);
    };
    [
      'ego:api:gift_added',
      'ego:api:gift_removed',
      'ego:api:gift_updated',
      'ego:api:discount_updated'
    ].forEach(eventName => window.addEventListener(eventName, refreshDrawer));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
